<template>
  <div :id="modalId" class="modal fade" tabindex="-1" :aria-labelledby="`${modalId}Label`" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 :id="`${modalId}Label`" class="modal-title text-primary translate">
            {{ title }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-sanitize-html="content" class="translate"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  });
</script>
